import {getService} from "~/lib/services/services-manager";
import {User} from "~/lib/models/user";
import {Group} from "~/lib/models/group";
import {generateQueryString} from "~/lib/querystring";

export const getUsersManagementDependencies = async clientUuid => {
  const service = getService("server-app");
  const result = await service.get(`/admin-client/users/${clientUuid}/management`);
  return {
    ...result.data,
    groups: result.data.groups.map( group => Group.fromPayload(group)),
  };
};

export const getUsers = async (clientUuid, params) => {
  const service = getService("server-app");
  const result = await service.get(`/admin-client/users/${clientUuid}${generateQueryString(params)}`);
  return {
    total: result.data.total,
    totalFiltered: result.data.totalFiltered,
    users: result.data.users.map( user => User.fromPayload(user))
  };
}

export const getUserDetails = async userUUID => {
  const service = getService("server-app");
  const result = await service.get(`/admin-client/users/${userUUID}/details`);
  return User.fromPayload(result.data.user);
}

export const toggleUserActivation = async userUUID => {
  const service = getService("server-app");
  await service.put(`/admin-client/users/${userUUID}/toggle-activation`);
}

export const removeUserAccount = async userUUID => {
  const service = getService("server-app");
  await service.delete(`/admin-client/users/${userUUID}`);
}

export const saveUserAccount = async (user:User, sendConfirmationEmail:boolean) => {
  const service = getService("server-app");
  const result = await service.post(`/admin-client/users`, {userData: user.toJSON(), sendConfirmationEmail});

  if(result.data.success === true){
    return User.fromPayload(result.data.user);
  } else {
    throw new Error(result.data.message);
  }

}
